import { useEffect } from "react"
import { useStore } from "stores/utils/use-store"
import { Button, Form, Space, Typography } from "antd"
import { observer } from "mobx-react"
import { notifications } from "notifications"
import { AnalyticsConfigType } from "domains/managingJson/store/types"
import { SettingsSection } from "./SettingsSection"

const { Title } = Typography

export const AnalyticsConfig = observer(() => {
  const { dataStore: { managingJsonStore } } = useStore()

  const [form] = Form.useForm<AnalyticsConfigType>()

  useEffect(() => {
    managingJsonStore.getData()
  }, [managingJsonStore])

  useEffect(() => {
    const analyticsConfigData = managingJsonStore.itemTypes?.find(
      item => item.type === "analyticsConfig",
    )

    if (analyticsConfigData) {
      const current = analyticsConfigData.data as AnalyticsConfigType
      form.setFieldsValue(current)
    }
  }, [form, managingJsonStore.itemTypes])

  const onFinishHandler = async({
    analyticsSampleRate,
    analyticsWhitelistedCountries,
  }: AnalyticsConfigType) => {
    managingJsonStore.funcAfterSuccess = async() => {
      notifications.success("Saved successfully")
      await managingJsonStore.getData()
    }

    const config = {
      name: "analyticsConfig",
      type: "analyticsConfig",
      data: {
        analyticsSampleRate,
        analyticsWhitelistedCountries,
      },
    } as const

    const exists = managingJsonStore.itemTypes?.some(
      item => item.type === "analyticsConfig",
    )

    exists
      ? await managingJsonStore.update(config)
      : await managingJsonStore.create(config)
  }

  return (
    <Form form={form} onFinish={onFinishHandler}>
      <Title level={2}>Analytics Config</Title>

      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <SettingsSection
          providerName="Buff"
          sampleRateName="analyticsSampleRate"
          whitelistedCountriesName="analyticsWhitelistedCountries"
        />

        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Space>
    </Form>
  )
})
